<template>
    <section id="result-search-page">
        <div class="container full-width">
            <div class="row">
                <div class="search-result-top">
                    <div class="top">
                        <div class="left">
                            <h2>
                                SBL Stock Requests
                            </h2>
                        </div>
                    </div>
                    <div class="bottom space-between">
                        <div class="left">
                            <span class="showing" v-if="total > 0">
                                <strong>Showing</strong>
                                <span>{{ from }}</span>-<span>{{ to }}</span> of <span>{{ total }}</span>
                                results
                            </span>
                        </div>
                    </div>
                </div>
                <div class="container-table">
                    <b-table
                            class="list-table"
                            :sort-by.sync="sort_by"
                            :sort-desc.sync="sort_desc"
                            :fields="fields"
                            :items="requests.map((item) => {item._showDetails = true; return item;})"
                            show-empty
                    >
                        <template v-slot:empty="scope">
                            No data is available...
                        </template>
                        <template v-slot:cell(image)="data">
                            <a :href="$laravelRoute('vehicle-stock-request.show', data.item.id)">
                                <img :src="data.item.vehicle_stock.front_image_url" alt="Front"
                                     v-if="data.item.vehicle_stock.front_image_url">
                            </a>
                        </template>
                        <template v-slot:cell(vehicle)="data">
                            <a v-if="data.item.vehicle_stock" :href="`/vehicle-stock/${data.item.vehicle_stock.id}`">
                                {{ data.item.vehicle_stock.year }}
                                {{ data.item.vehicle_stock.make }}
                                {{ data.item.vehicle_stock.model }}
                            </a>
                        </template>
                        <template v-slot:cell(first_name)="data">
                            <a v-if="data.item.user_id" :href="`/users/${data.item.user_id}`">
                                {{ data.item.first_name }}
                            </a>
                            <span v-else>{{ data.item.first_name }}</span>
                        </template>
                        <template v-slot:cell(actions)="data">
                            <a :href="$laravelRoute('vehicle-stock.show', data.item.id)">View</a>
                        </template>
                    </b-table>
                    <div class="bottom-container-result d-flex justify-content-end flex-wrap">
                        <div class="d-flex justify-content-end">
                            <b-pagination
                                    v-if="total > 0"
                                    :total-rows="total"
                                    v-model="current_page"
                                    :per-page="per_page"
                            ></b-pagination>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    import { mapState, mapActions } from 'vuex'

    export default {
        created(){
            this.$store.dispatch('vehicleStockRequests/get', {
                sort_by: this.sortBy,
                sort_desc: this.sortDesc
            });
        },
        data() {
            return {
                sort_by: 'name',
                sort_desc: true,
                selected_search: null,
                viewType: 'grid',
                fields: [
                    {label: '', key: 'image',},
                    {label: 'Vehicle', key: 'vehicle', sortable: false},
                    {label: 'First Name', key: 'first_name', sortable: true},
                    {label: 'Last Name', key: 'last_name', sortable: true},
                    {label: 'Company', key: 'company', sortable: true},
                    {label: 'Address', key: 'address', sortable: true},
                    {label: 'City', key: 'city', sortable: true},
                    {label: 'Phone', key: 'phone', sortable: true},
                    {label: 'Fax', key: 'fax', sortable: true},
                    {label: 'Email', key: 'email', sortable: true},
                ],
            }
        },
        computed: {
            ...mapState('vehicleStockRequests', {
                requests: state => state.all,
                per_page: state => state.per_page,
                from: state => state.from,
                to: state => state.to,
                last_page: state => state.last_page,
                total: state => state.total,
            }),
            current_page: {
                get(){
                    return this.$store.getters['vehicleStockRequests/get'];
                },
                set(value){
                    return this.$store.dispatch('vehicleStockRequests/get',
                        {page: value});
                }
            }
        },
        methods: {
            getTime(data) {
                return window.moment(data).format('HH:mm')
            },
        }
    }

</script>



// WEBPACK FOOTER //
// resources/js/components/VehicleStock/RequestsListPage.vue